import TranslationApiProxyService from '@/services/TranslationApiService';

export default {
  getTranslations(language) {
    return TranslationApiProxyService.get('/translation/fetch/' + language);
  },
};
